import React from 'react';

function OurServices() {
    return (
        <div className="our-services">
            <h1><strong>Our Services</strong></h1>
            <p>At <strong>Digital Wardrobe</strong>, we offer a variety of services designed to help you stay organized, stylish, and ready for any occasion. Whether you're planning a trip, preparing for a special event, or managing your daily wardrobe, our platform has the tools you need to manage your outfits efficiently!</p>

            <h3><strong>Uploading Clothing Items</strong></h3>
            <p>Our platform allows you to upload your clothing items by filling in the related details and image of the items. You can then edit or delete them as well as use them to create an outfit or a travel list!</p>

            <h3><strong>Outfits Management</strong></h3>
            <p>Our platform allows you to manage your entire wardrobe with ease. You can create outfits that suit your needs and fill in related information like the occasion they are most suitable for. Easily track and organize your clothing items, so you never forget what you have in your wardrobe.</p>

            <h3><strong>Occasions Planning</strong></h3>
            <p>Whether it's a casual day out, a formal event, or a special occasion, Digital Wardrobe helps you pre-plan your outfits in advance. Save time and stress by organizing your wardrobe and planning your outfits for upcoming events without hesitating to find what to wear.</p>

            <h3><strong>Travel Lists</strong></h3>
            <p>
                Going on a trip? Create travel-specific packing lists, ensuring you're always prepared for your adventures and plans. Decide which clothing items to take with you, and pack efficiently with our custom travel lists. Never overpack or forget an essential clothing item again!
            </p>

            <p>At <strong>Digital Wardrobe</strong>, we are committed to helping you feel confident, organized, and stylish with every creation you make throughout your journey with us!</p>
        </div>
    );
}

export default OurServices;